module.exports = "/_next/static/images/RimaNemtu-e0bc977c2ff3af968370a5bdf29a49ae.webp";